module.exports = __webpack_public_path__ + "static/img/strona_048.3b225318.jpg";